(() => {
  'use strict';
  if (globalThis.JaxBulkCheckout) return;
  // Enable only after the matching native Shopify discount rules are verified.
  // This is the sole activation flag; neither a URL nor a saved design enables checkout.
  const enabled = true;
  const source = 'bulk-builder-v1';
  let policy = null;
  let mapping = null;
  const script = document.currentScript;
  // reviewBy is a maintenance reminder; exact prices and catalog identities gate checkout.
  const current = () => policy?.version === 1 && policy.currency === 'USD';
  const originalVariantId = id => {
    const key = String(id);
    if (Object.hasOwn(mapping?.variants || {}, key)) return key;
    return Object.keys(mapping?.variants || {}).find(original => Object.values(mapping.variants[original].tiers || {}).includes(key)) || null;
  };
  const originalProductId = id => mapping?.variants?.[originalVariantId(id)]?.originalProductId || null;
  const isEligibleVariant = id => Boolean(current() && Number.isSafeInteger(policy.variants?.[originalVariantId(id) || String(id)]?.basePrice));
  const checkoutVariant = (id, quantity) => {
    const original = originalVariantId(id), rule = mapping?.variants?.[original];
    if (!rule || !Number.isInteger(quantity) || quantity < 10 || quantity > 999 || !isEligibleVariant(original) || policy.variants[original].basePrice !== rule.basePrice) return null;
    const threshold = [10, 24, 48, 100].filter(minimum => quantity >= minimum).at(-1);
    const variantId = rule.tiers[String(threshold)];
    return variantId ? { variantId, productId: rule.productId, originalVariantId: original, originalProductId: rule.originalProductId, threshold } : null;
  };
  const classify = document => globalThis.JaxBulkEligibility?.classify({ document,
    eligibleVariantIds: current() ? Object.keys(policy.variants) : [], bulkSource: document?.bulkSource }) || { eligible: false, maxQuantity: 99, properties: {} };
  const quantityAllowed = (document, quantity) => Number.isInteger(quantity) && quantity >= 1 && quantity <= (classify(document).eligible ? 999 : 99);
  const quote = ({ document, variant, quantity, currency = 'USD', style = 'same' }) => {
    const qualified = classify(document).eligible;
    return globalThis.JaxBulkPricing?.quote({ policy, variant, quantity, currency, style: qualified ? style : 'names', live: enabled, qualified }) || { valid: false, canOrder: false, reason: 'unavailable' };
  };
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  const ready = Promise.resolve().then(() => {
    const url = script?.dataset.policyUrl;
    const mappingUrl = script?.dataset.catalogUrl;
    if (!url || !mappingUrl) throw new Error('bulk_policy');
    return Promise.all([url, mappingUrl].map(address => fetch(address, { credentials: 'same-origin', signal: controller.signal }).then(response => {
      if (!response.ok) throw new Error('bulk_policy'); return response.json();
    })));
  }).then(([value, catalog]) => {
      if (value?.version !== 1 || !value.variants || !Array.isArray(value.tiers) || catalog?.version !== 1 || catalog.currency !== 'USD' || !catalog.variants) throw new Error('bulk_policy');
      const numeric = id => typeof id === 'string' && /^[1-9]\d{0,23}$/.test(id);
      const seen = new Set();
      if (!numeric(catalog.bulkProductId) || Object.entries(catalog.variants).some(([id, rule]) => !numeric(id) || !numeric(rule.originalProductId) || rule.productId !== catalog.bulkProductId || rule.basePrice !== value.variants[id]?.basePrice || [10,24,48,100].some(tier => {
        const variant = rule.tiers?.[tier]; if (!numeric(variant) || seen.has(variant)) return true; seen.add(variant); return false;
      }))) throw new Error('bulk_catalog');
      policy = value; mapping = catalog;
      return current();
    }).catch(() => false).finally(() => { clearTimeout(timeout); document.dispatchEvent(new CustomEvent('jax:bulk-policy-ready')); });
  globalThis.JaxBulkCheckout = Object.freeze({ enabled, source, ready, get policy() { return policy; }, get mapping() { return mapping; }, get catalog() { return mapping; }, originalVariantId, originalProductId, checkoutVariant, isEligibleVariant, classify, quantityAllowed, quote });
})();
